import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidCategorise } from '../../../../../mechanics/rid-categorise/rid-categorise';

@Component({
  selector: 'app-categorise-word-to-audio-page',
  imports: [RidCategorise],
  templateUrl: './categorise-word-to-audio-page.html',
})
export class CategoriseWordToAudioPage {
  protected readonly $router = inject(Router);
}
